import { useAtomValue } from 'jotai';

import { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import { flagsAtom } from '@growthBookExperimentation/Atoms/Flags.atom';

import { adminFeeMessagesAtom } from './AdminFee.atoms';
import { defaultAdminFeeMessages } from './AdminFee.messages';
import { getAdminFee } from './AdminFee.utils';

export const useAdminFee = ({ vehicle }: { vehicle: Vehicle | null }) => {
  const flags = useAtomValue(flagsAtom);
  const messages = useAtomValue(adminFeeMessagesAtom) || defaultAdminFeeMessages;
  const { shouldShowEcomAdminFee, shouldShowD2cAdminFee } = getAdminFee({
    flags,
    vehicle,
  });

  let fee = '';

  if (shouldShowEcomAdminFee) {
    fee = messages.ecom;
  }
  if (shouldShowD2cAdminFee) {
    fee = messages.d2c;
  }

  return {
    fee,
    messages: messages,
    shouldShowEcomAdminFee,
    shouldShowD2cAdminFee,
  };
};
